import axios from 'axios'

export const screenSwipe = ({ commit }) => {
  commit('screenSwipe', true)
}

export const screenSwipeStop = ({ commit }) => {
  commit('screenSwipe', false)
}

export const getPeople = async ({ commit }, { page = 1, order = 'asc', perPage = 14, additionalParam = '' } = {}) => {
  try {
    commit('loadingToggle', true)
    const url = `${process.env.VUE_APP_URL}/wp-json/wp/v2/people?filter[meta_key]=priority&filter[meta_compare]==&filter[meta_value]=1&per_page=${perPage}&order=${order}&page=${page}${additionalParam}`
    const response = await axios.get(url)
    setTimeout(() => {
      commit('loadingToggle', false)
    }, 2000)
    commit('setPeople', response.data)
    commit('addOffset', perPage)
  } catch (err) {
    //
  }
}

export const getSlides = async ({ commit }) => {
  try {
    const url = `${process.env.VUE_APP_URL}/wp-json/wp/v2/carousel_slide?per_page=100&status=publish`
    const response = await axios.get(url)
    commit('setSlides', response.data.sort((a, b) => (a.acf && a.acf.index ? parseInt(a.acf.index) : 999) - (b.acf && b.acf.index ? parseInt(b.acf.index) : 999)).map(_ => _.acf && _.acf.image && _.acf.image.url ? _.acf.image.url : null).filter(_ => _ != null))

    const urlIOS = `${process.env.VUE_APP_URL}/wp-json/wp/v2/carousel_slide_ios?per_page=100&status=publish`
    const responseIOS = await axios.get(urlIOS)
    commit('setSlidesIOS', responseIOS.data.sort((a, b) => (a.acf && a.acf.index ? parseInt(a.acf.index) : 999) - (b.acf && b.acf.index ? parseInt(b.acf.index) : 999)).map(_ => _.acf && _.acf.image && _.acf.image.url ? _.acf.image.url : null).filter(_ => _ != null))
  } catch (err) {
    //
  }
}
